<div class="mainstepcontent row w100">
  <div class="leftside col grow-1 gap-24" #chatContent>
    <div class="col gap-16">
      <div class="col">
        <div class="stepcounter">
          STEP {{ thisStepCount }}/{{ totalStepCount }}
        </div>
        <h1>{{ step?.name }}</h1>
      </div>
      <!--
      <div
        class="instructions align-center row gap-8 pointer"
        (click)="openInstructions()"
      >
        <rr-icon name="info"></rr-icon>
        <div class="underline">Instructions</div>
      </div>
    -->
    </div>
    <div class="secondary-text">
      Let's empathize with your target user to gain a deeper understanding of
      their experience, perspective, and challenges.
    </div>

    <div
      class="innerstep col w100"
      *ngFor="let item of suggestionStorage; index as i"
    >
      <div class="row gap-24 w100">
        <img
          [src]="'images/porblem_shadow_left_side_' + (i + 1) + '.jpeg'"
          alt=""
          class="step-image"
          [ngClass]="activeStep < i + 1 ? 'small' : ''"
        />
        <div class="col gap-8 grow-1" *ngIf="activeStep === i + 1">
          <div class="uppercase">
            Question {{ i + 1 }}/{{ suggestionStorage.length }}
          </div>
          <rr-insight-control
            id="insight-control-{{ i }}"
            [headline]="questionHeadlines[i]"
            [placeholder]="questionHeadlines[i].sub"
            (nextQuestion)="nextStep()"
            (suggestOptions)="loadSuggestionsForQuestion()"
            (addSuggestion)="addSuggestion($event)"
            (updateSuggestion)="updateSuggestiontext($event)"
            (deleteSuggestion)="deleteSuggestion($event)"
            [options]="suggestionStorage[i]"
            [suggestions]="currentSuggestions"
            class="w100"
          ></rr-insight-control>
        </div>
        <div
          class="col gap-4"
          [ngClass]="activeStep < i + 1 ? 'disabled' : 'questionHover'"
          (click)="activeStep >= i + 1 ? setStep(i + 1) : null"
          *ngIf="activeStep !== i + 1"
        >
          <h3>
            {{ questionHeadlines[i].main }}
          </h3>
          <div>{{ questionHeadlines[i].sub }}</div>
          <div class="col gap-8 w100">
            <div
              class="suggestion w100"
              *ngFor="let suggestion of suggestionStorage[i]"
            >
              {{ suggestion.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <rr-divider></rr-divider>
    <div class="proceed col gap-16">
      <h4 class="strong">How shall we proceed?</h4>
      <div class="row gap-16 align-center">
        <rr-btn type="Link" class="underline" (click)="restartAgain()"
          >Reset & Start Again</rr-btn
        >
      </div>
    </div>
  </div>
  <div class="rightside col gap-24" *ngIf="suggestionStorage.length > 0">
    <div class="persona-image w100" [style]="persona?.image"></div>
    <!-- <img [src]="persona?.image" alt="" /> -->
    <div class="persona-info">
      <div class="subtitle">
        {{ persona?.occupation || persona?.demographics?.occupation }}
      </div>
      <div class="title">{{ persona?.name }}</div>
    </div>
  </div>
</div>
<rr-spinner *ngIf="loading == true"></rr-spinner>
